/**
 * Publicly accessible routes (no authentication required). Kept in one place so
 * both the layout chrome and the boot-sequence opt-out can share the same list.
 */
export const publicRoutes = [
  "/",
  "/auth/login",
  "/auth/signup",
  "/auth/forgot-password",
  "/auth/reset-password",
  "/auth/verify-email",
  "/auth/email-confirmed",
  "/auth/error",
  "/auth/session-expired",
  "/auth/complete-profile",
  "/auth/link-conflict",
  "/auth/callback",
  "/onboarding",
  "/about",
  "/pricing",
  "/faq",
  "/community/faq",
  "/ask",
  "/tools/notes",
  "/contact",
  "/courses",
  "/onboarding/courses",
  "/privacy",
  "/terms",
  "/pay",
  "/rate-limited",
  "/maintenance",
  "/accessibility",
  "/events",
  "/404",
  "/500",
  "/403",
  "/offline",
  "/success",
  "/loading",
  "/splash",
];

/** Path prefixes that are public without being in the explicit list above. */
export const publicPrefixes = ["/auth/", "/events/", "/u/"];
